import React, { useRef, useEffect } from "react";
import { Link } from "react-scroll";


import { NavbarData } from "./NavbarData";
import "./SideBar.css";
import * as IoIcons from "react-icons/io";
import { IconContext } from "react-icons/lib";

const SideBar = ({ sideBarState, setSideBarState }) => {
  const ref = useRef();
  const toggleSideBar = () => {
    setSideBarState(!sideBarState);
  };

  useEffect(() => {
    const onBodyClick = () => {
      document.body.addEventListener("click", (event) => {
        // if (event.target.className === "items list hamburger icon") {
        //   console.log(100, event.target);
        //   return;
        // } else {
        if (ref.current.contains(event.target)) {
          console.log(200, event.target);

          return;
        } else {
          // console.log(200, event.target);
          // sideBarState
          toggleSideBar();
        }
        //}
      });
    };
    // if (sideBarState) {
    //   onBodyClick();
    // }

    // const onBodyCliked = (event) => {
    //    if (ref.current.contains(event.target)) {
    //      console.log(200);
    //      return;
    //    }
    //    closeSideBar();
    //  };
    // const sideBar = document.querySelector(".sidebar.containa");
    // if (sideBarState) {
    //   console.log(sideBarState);
    //   const addListener = () => {
    //     sideBar.addEventListener("click", onBodyCliked);
    //   };
    //   addListener();
    // }
    return () => {
      document.body.removeEventListener("click", onBodyClick);
    };
  }, [sideBarState]);

  const variants = {
    open: { opacity: 1, x: 0 },
    closed: { opacity: 0, x: "-100%" },
  };
  return (
    <IconContext.Provider value={{ size: "32px", color: "rgb(33, 150, 243)" }}>
      <div
        ref={ref}
        animate={sideBarState ? "open" : "closed"}
        variants={variants}
        className={
          sideBarState ? "sidebar containa relative active" : "sidebar containa relative"
        }
      >
        <li className="close icon">
          <IoIcons.IoMdClose
            onClick={() => {
              toggleSideBar();
            }}
          />
        </li>
        {NavbarData.map((item) => {
          return (
            <Link
              to={`${item.name.toLowerCase()}`}
              smooth={true}
              duration={1000}
              key={item.name.toLowerCase()}
              className={item.name.toLowerCase() + "link"}
            >
              <li
                className="sidebar list item"
                onClick={() => {
                  toggleSideBar();
                }}
                id={item.name}
              >
                <span className="icon">{item.icon}</span>
                <span className="name">{item.name}</span>
              </li>
            </Link>
          );
        })}

        <div className="signature absolute bottom-0">
          <h6>&copy;NKWETACHA</h6>
        </div>
      </div>
    </IconContext.Provider>
  );
};

export default SideBar;
